import {SETTINGS_SCOPE_SECTIONS} from "@/store/constants";
import {selectedCompanyIdAtom, settingsModalAtom} from "@/store/jotaiAtoms";
import {createFileRoute, redirect} from "@tanstack/react-router";
import {zodValidator} from "@tanstack/zod-adapter";
import {getDefaultStore} from "jotai";
import {z} from "zod";

export const Route = createFileRoute("/_authenticated/_agency/agency/$agencyId/edit")({
  params: {
    parse: raw => ({agencyId: +raw.agencyId}),
    stringify: params => ({agencyId: params.agencyId?.toString()}),
  },
  validateSearch: zodValidator(
    z.object({
      section: z.enum(SETTINGS_SCOPE_SECTIONS).optional().catch(undefined),
    }),
  ),
  loaderDeps: ({search}) => ({section: search.section}),
  loader: ({deps, params}) => {
    getDefaultStore().set(selectedCompanyIdAtom, null);
    getDefaultStore().set(settingsModalAtom, {
      scope: {id: params.agencyId, type: "agency"},
      section: deps.section ?? "info",
    });

    throw redirect({to: "/agency/$agencyId", params: {agencyId: params.agencyId}, replace: true, search: true});
  },
});
